import * as http from '@/utils/http';

// initial state
const state = {
  allValue: [],
  info: {},
};

// getters
const getters = {
  studentInfo: state => state.info,
};

// actions
const actions = {
  /**
   * 获取用户信息
   *
   * @author Cong Peijun <congpeijun@jiemo.net>
   * @param  {Function} options.commit
   * @param  {Number} userid 用户userid
   * @return {Permissio}
   */
  getInfo({ commit }, payload = {}) {
    const data = payload.type ? { type: payload.type } : '';
    return http._get({
      url: `/index/student/read/id/${payload.userid}`,
      data
    }).then((response) => {
      commit('updateInfo', response.data);
    });
  }
};

// mutations
const mutations = {
  updateInfo(state, info) {
    state.info = info;
  },

  updateValue(state, value) {
    state.allValue = value;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
